import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { TooltipWrapper, TooltipContainer } from './tooltip.style';

/**
 * Shared tooltip component
 * @param {object} props - Object containing component props
 * @param {func} props.content - Text content to be displayed in the tooltip
 * @param {object} props.children - Element(s) to wrap for the hover target
 * @param {object} props.position - Tooltip position relative to target
 * @param {object} props.delay - Amount of time in seconds to wait before displaying
 * @return {element} - The tooltip element
 */
const Tooltip = ({
  content, children, position, delay,
}) => {
  const wrapper = useRef(null);
  const tooltip = useRef(null);
  const [wrapperRect, setWrapperRect] = useState(null);
  const [tooltipRect, setTooltipRect] = useState(null);

  useEffect(() => {
    setWrapperRect(wrapper.current?.getBoundingClientRect());
    setTooltipRect(tooltip.current?.getBoundingClientRect());
  }, []);

  return (
    <TooltipWrapper data-testid="tooltip-wrapper" delay={delay} ref={wrapper}>
      {children}
      <TooltipContainer
        ref={tooltip}
        position={position}
        targetRect={wrapperRect}
        tooltipRect={tooltipRect}
      >
        {content}
      </TooltipContainer>
    </TooltipWrapper>
  );
};

Tooltip.propTypes = {
  content: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  position: PropTypes.string,
  delay: PropTypes.number,
};

Tooltip.defaultProps = {
  content: '',
  children: null,
  position: 'bottom',
  delay: 0,
};

export default Tooltip;
